<template>
  <section class="before-after-section py-5 bg-white">
    <div class="container text-center">
      <div class="row justify-content-center mb-5">
        <div class="col-lg-8">
          <span
            class="badge badge-danger-light text-danger-dark
           font-weight-bold px-3 py-2 text-uppercase mb-2"
          >
            El verdadero cambio en tu rutina
          </span>
          <h2 class="h1 font-weight-bold text-dark-blue">
            ¿Cómo cambia tu vida profesional con AMII?
          </h2>
          <p class="lead text-muted">
            La diferencia entre terminar tu día agotado respondiendo
            mensajes o llegar a tiempo a cenar con tu familia.
          </p>
        </div>
      </div>

      <div class="row align-items-stretch">
        <!-- SIN AMII -->
        <div class="col-md-6 mb-4 mb-md-0 scroll-reveal">
          <div
            class="card h-100 border-danger-subtle bg-light-red
           rounded-xl p-4 text-left shadow-xs"
          >
            <div class="d-flex align-items-center mb-3">
              <span class="badge badge-danger p-2 rounded-circle mr-3">❌</span>
              <h3 class="h4 font-weight-bold text-danger mb-0">
                Tu día SIN AMII
              </h3>
            </div>

            <ul class="list-unstyled mb-0">
              <li class="d-flex mb-3">
                <span class="text-danger mr-2">✦</span>
                <span class="text-dark"><strong>Estrés constante en
                  la noche:</strong> Decenas de mensajes pendientes
                  por responder en WhatsApp.</span>
              </li>
              <li class="d-flex mb-3">
                <span class="text-danger mr-2">✦</span>
                <span class="text-dark"><strong>Horarios y espacios
                  perdidos:</strong> Pacientes que olvidadizos te
                  dejan esperando en el consultorio.</span>
              </li>
              <li class="d-flex mb-3">
                <span class="text-danger mr-2">✦</span>
                <span class="text-dark"><strong>
                  Desorden de agenda:</strong> Cuadernos deshojados o
                  planillas complicadas compartidas con recepcionistas.</span>
              </li>
              <li class="d-flex">
                <span class="text-danger mr-2">✦</span>
                <span class="text-dark"><strong>
                  Pérdida de tiempo redactando:</strong>
                  Escribir manualmente recetas e informes repetitivos
                  consulta tras consulta.</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- CON AMII -->
        <div class="col-md-6 scroll-reveal delay-1">
          <div
            class="card h-100 border-success-subtle bg-light-green
           rounded-xl p-4 text-left shadow-sm"
          >
            <div class="d-flex align-items-center mb-3">
              <span class="badge badge-success p-2 rounded-circle mr-3">✅</span>
              <h3 class="h4 font-weight-bold text-success-base mb-0">
                Tu día CON AMII
              </h3>
            </div>

            <ul class="list-unstyled mb-0">
              <li class="d-flex mb-3">
                <span class="text-success-base mr-2">✔</span>
                <span class="text-dark"><strong>
                  Paz y tiempo libre:</strong> AmiiBot responde las
                  dudas y agenda citas mientras tú descansas.</span>
              </li>
              <li class="d-flex mb-3">
                <span class="text-success-base mr-2">✔</span>
                <span class="text-dark"><strong>
                  Cupos siempre llenos:
                </strong> Recordatorios automáticos que reasignan
                  lugares liberados de inmediato.</span>
              </li>
              <li class="d-flex mb-3">
                <span class="text-success-base mr-2">✔</span>
                <span class="text-dark"><strong>Agenda inteligente
                  sincronizada:</strong> Acceso seguro y en tiempo
                  real para ti y todo tu equipo recepcionista.</span>
              </li>
              <li class="d-flex">
                <span class="text-success-base mr-2">✔</span>
                <span class="text-dark"><strong>Documentos listos en 1
                  Clic:</strong> Recipes, constancias e informes con
                  tu logo e identidad corporativa al instante.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BeforeAfterComparison',
  mounted() {
    this.initScrollObserver();
  },
  methods: {
    initScrollObserver() {
      if (
        typeof window === 'undefined'
        || !('IntersectionObserver' in window)
      ) {
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      }, {threshold: 0.15});

      this.$el.querySelectorAll('.scroll-reveal')
          .forEach((el) => observer.observe(el));
    },
  },
};
</script>

<style scoped>
.text-dark-blue {
  color: #002196;
}
.scroll-reveal {
  opacity: 1;
  transform: none;
  transition: opacity 0.6s ease, transform 0.6s ease;
}
@media (prefers-reduced-motion: no-preference) {
  .scroll-reveal {
    opacity: 0;
    transform: translateY(24px);
  }
  .scroll-reveal.is-visible {
    opacity: 1;
    transform: none;
  }
  .scroll-reveal.delay-1 {
    transition-delay: 0.12s;
  }
}
.bg-light-red {
  background-color: #fff8f8;
  border: 1px solid #ffe3e3;
}
.bg-light-green {
  background-color: #f4fbf7;
  border: 2px solid #04c06c;
}
.badge-danger-light {
  background-color: #ffd6d6;
}
.text-danger-dark {
  color: #a80010;
}
</style>
